 <style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

 <template>
  <div>
    <el-tabs>
      <el-tab-pane label="BaseInfo Configuration">
        <el-form class="pop-form-wrap width-box w600" label-width="100px" :model="formData" ref="projectInfoForm" v-if="formData">
          <el-form-item label="Seo Title" prop="ScSeoTitle">
            <el-input size="small" v-model="formData.ScSeoTitle"></el-input>
          </el-form-item>
          <el-form-item label="Seo Description" prop="ScSeoDescription">
            <el-input size="small" v-model="formData.ScSeoDescription" :autosize="{minRows: 4}" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="Seo Key" prop="ScSeoKey">
            <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
          </el-form-item>
          <el-form-item label="Custom Telephone" prop="ScTelephone">
            <el-input size="small" v-model="formData.ScTelephone"></el-input>
          </el-form-item>
          <el-form-item label="Company Email" prop="ScEmail">
            <el-input size="small" v-model="formData.ScEmail"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="pop-center-btn-wrap">
              <el-button type="primary" @click="doUpdate('projectInfoForm')">Save</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Advanced Configuration">
        <el-form class="pop-form-wrap width-box w600" label-width="100px" :model="formData" ref="infoForm" v-if="formData">
          <el-form-item label="Statistical Code" prop="ScStatisticalcode">
            <el-input size="small" v-model="formData.ScStatisticalcode" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="Js Code" prop="ScJscode">
            <el-input size="small" v-model="formData.ScJscode" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="Business Code" prop="ScBusinesscode">
            <el-input size="small" v-model="formData.ScBusinesscode" type="textarea"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="pop-center-btn-wrap">
              <el-button type="primary" @click="update2DataAjax('infoForm')">Save</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tools from '@/components/common/tools'
import imgUpload from '@/libcomponents/img-upload/img-upload'

// 数据对象
let dataStore = tools.createDataStore({
  ScSeoTitle: '',
  ScSeoDescription: '',
  ScSeoKey: '',
  ScTelephone: '',
  ScEmail: '',
  ScStatisticalCode: '',
  ScJscode: '',
  ScBusinessCode: ''
})

// 请求相关操作
let page = {
  methods: {
    // 修改操作
    updateDataAjax(id, state) {
      let data = tools.getModel(this.formData)
      data.ScSeoKey = this.dynamicTags.join(',')
      tools.commonAjax.call(this, true, '/Ajax/UpdateConfigInAdmin', data).then(() => {
        this.$message.success('Success')
        // 修改成功
        this.$emit('updateSuccess')
      })
    },
    // 修改操作
    update2DataAjax(id, state) {
      let data = tools.getModel(this.formData)
      tools.commonAjax.call(this, true, '/Ajax/UpdateConfigInAdmin', data).then(() => {
        this.$message.success('Success')
        this.$emit('updateSuccess')
      })
    }
  }
}

export default {
  name: 'WelcomeForm',
  componentName: 'WelcomeForm',
  mixins: [page],
  components: {
    imgUpload
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      formData: dataStore.getDefaultData()
    }
  },
  methods: {
    // 重置表单值
    resetValue() {
      this.formData = dataStore.getDefaultData()
    },
    // 设置表单值
    setValue(value) {
      var data = tools.extendData(dataStore.getDefaultData(), value || {})
      this.dynamicTags = data.ScSeoKey ? data.ScSeoKey.split(',') : []
      this.formData = data
    },
    // 修改
    doUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>




// WEBPACK FOOTER //
// WelcomeForm.vue?8c268578